<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-10-14 11:12:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-08 10:50:45
 * @FilePath: /goldenSalesMobile/src/views/ShoppingList/index.vue
 * @Description: 消费者购物商品列表
-->
<template>
  <div class="group-list-container f-1" id="#listRef">
    <!-- banner -->
    <div class="banner-list" v-if="bannerList.length > 0">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <van-image :src="`${item.CdnUrl}/${item.ImagePath}`" fit="cover" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- goods-list -->
    <div class="tab-list" v-if="tabList.length > 0">
      <van-tabs
        v-model="activeTabName"
        swipeable
        sticky
        color="var(--tc)"
        title-active-color="var(--tc)"
        title-inactive-color="#666666"
        @change="onTabChange"
      >
        <van-tab
          v-for="(item, index) in tabList"
          :key="index"
          :name="item.Id"
          :title="item.Name"
          :swipe-threshold="5"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            :error.sync="loadError"
            :immediate-check="false"
            :offset="30"
            error-text="请求失败，点击重新加载"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              class="goods-item"
              v-for="(subItem, subIndex) in item.goodsList"
              :key="subIndex"
              @click="onCheckDetail(subItem.Id, subIndex)"
            >
              <div class="goods-image">
                <van-image
                  :src="subItem.imgUrl || $root.defaultImg"
                  fit="cover"
                  width="100"
                  height="100"
                  radius="8"
                />
              </div>
              <div class="dotted-box">
                <p class="main-txt">{{ subItem.TicketName }}</p>
                <div class="money-box">
                  <div class="sub-money" v-if="subItem.MarketPrice">
                    ￥{{ subItem.MarketPrice }}
                  </div>
                  <div class="main-money c-tc">
                    <span class="c-yang">¥</span>
                    <span class="">{{ subItem.GrouponPrice }}</span>
                  </div>
                </div>
              </div>
              <!-- <div
                  class="sub-txt"
                  v-html="
                    subItem.GoodsList.map(
                      (m) => `${m.GoodsName} x ${m.NumberCount}`
                    ).join('　')
                  "
                ></div> -->
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { testGetAESPhone, silentLogin } from "@/api/user";
import { getStoreBanner } from "@/api/system";
import { getGroupClassifyType, getGroupGoodsList } from "@/api/activity";
// ~/jinguiProject/goldenTicket/goldenSalesMobile-in-mobile/src/views/ShoppingList
// ~/jinguiProject/goldenTicket/goldenSalesMobile-in-mobile/src/views/ShoppingList/index.vue
export default {
  props: {
    vpnId: [String, Number],
    toScrollPosition: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    vpnId(val) {
      this.sonVpnId = val;
      this.init();
    },
    toScrollPosition(val) {
      this.sonScrollPosition = val;
    },
  },
  data() {
    return {
      userInfo: {
        phone: this.$route.query.phone,
        name: this.$route.query.userName,
        headImageUrl: this.$route.query.headImageUrl,
      },
      bannerList: [],
      loading: false,
      finished: false,
      loadError: false,
      activeTabName: "",
      tabList: [],
      sonVpnId: "",
      pageIndex: 0,
      pageSize: 5,
      rememberPosition: false,
      sonScrollPosition: this.toScrollPosition,
    };
  },

  created() {
    this.sonVpnId = this.vpnId;
    this.init();
  },

  methods: {
    // 初始化
    async init() {
      // 加载产品列表前5条数据
      if (this.tabList.length > 0) {
        this.getProducts();
        return;
      }
      getGroupClassifyType({ id: this.sonVpnId }).then((res) => {
        let data = res;
        if (data instanceof Array && data.length > 0) {
          this.tabList.unshift({ Name: "全部", Id: "", goodsList: [] });
          data.map((item) => {
            item.goodsList = [];
            this.tabList.push(item);
          });
          this.$nextTick(() => {});
          this.getProducts();
        }
      });
    },

    // 产品列表请求方法
    getProducts() {
      let params = {
        query: {
          // vpnId: '299792465',
          VpnId: this.sonVpnId,
          EventTypeId: 2,
          ProductTypeId: this.activeTabName,
          // type: this.activeTabName,
        },
        pager: {
          pageindex: this.pageIndex,
          pagesize: this.pageSize,
        },
      };
      getGroupGoodsList(params)
        .then((res) => {
          this.loadError = false;
          let data = res.Items;
          if (data instanceof Array) {
            data.map((item) => {
              const ticketItem =
                item.DrawTicketItems && item.DrawTicketItems[0];
              // 产品列表图片
              const imgArr = ticketItem.Claims;
              if (imgArr instanceof Array && imgArr.length > 0) {
                const imgItem = imgArr.find((subItem) => subItem.TypeId === 0);
                if (imgItem) {
                  item.imgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
                }
                // imgArr.map((subItem) => {
                //   if (subItem.TypeId === 0) {
                //     item.imgUrl = `${subItem.CdnUrl}/${subItem.Value}`;
                //   }
                // });
              }
              item.TicketName = ticketItem.TicketName;
              item.GrouponPrice = ticketItem.GrouponPrice;
              item.MarketPrice = ticketItem.MarketPrice;
            });
            // 添加产品数据到对应的tabList中
            this.tabList.map((item) => {
              if (item.Id === this.activeTabName) {
                if (this.pageIndex > 1) {
                  // 合并
                  item.goodsList = item.goodsList.concat(data);
                } else {
                  // 覆盖
                  item.goodsList = data;
                }
              }
            });
            // 没有更多数据时结束上拉加载事件
            if (data.length < this.pageSize || data.length === 0) {
              this.finished = true;
            }
            // 加载结束
            this.loading = false;

            // 离开首页再返回时，重新定位到离开时的位置
            let historyScollTop = this.$store.state.historyScollTop;
            console.log(historyScollTop);
            if (historyScollTop) {
              this.$nextTick(() => {
                window.scrollTo(0, historyScollTop);
              });
            }
          }
        })
        .catch((err) => {
          this.finished = false;
          this.loadError = true;
          this.loading = false;
          this.tabList.map((item) => {
            item.goodsList = [];
          });
        });
    },

    // 上拉加载
    onLoad() {
      this.pageIndex++;
      this.getProducts();
    },

    // tab切换
    onTabChange(val) {
      this.finished = false;
      this.loading = true;
      this.activeTabName = val;
      this.pageIndex = 0;
      this.getProducts();
    },

    // 查看产品详情
    onCheckDetail(productId, i) {
      this.$router.push({
        name: "FlashSalePage",
        params: { id: productId },
        query: {
          fromPage: "buy",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.group-list-container {
  .banner-list {
    width: 100%;
    height: 300px;

    > .my-swipe {
      width: 100%;
      height: 100%;
      // border-radius: 16px;
      // overflow: hidden;

      &::v-deep .van-image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .tab-list {
    background: #fff;
    margin-bottom: 100px;
    box-sizing: border-box;
    border-radius: 16px;

    .goods-item {
      padding: 24px;
      /* height: 340px; */
      // margin: 100px 0 0 0;
      display: flex;
      border-bottom: 1px solid #eee;
      .goods-image {
      }

      .dotted-box {
        margin-left: 24px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .goods-name {
          margin-bottom: 12px;
          line-height: 48px;
          font-size: 34px;
          font-weight: 500;
          color: #333333;
        }
        .main-txt {
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 44px;
        }

        .goods-intro,
        .goods-salesCount {
          min-height: 34px;
          margin-bottom: 10px;
          line-height: 34px;
          font-size: 24px;
          color: #888888;
        }

        .goods-salesCount {
          > a > b {
            font-weight: normal;
            text-decoration: line-through;
          }
        }

        .goods-name,
        .goods-intro {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; // 用来限制在一个块元素显示的文本的行数
          overflow: hidden;
        }

        .goods-price {
          @include flex-box(space-between);

          > span {
            line-height: 30px;
            font-size: 40px;
            font-weight: bold;
            color: #fe4600;

            > a {
              font-size: 24px;
            }
          }

          &::v-deep .van-button {
            width: 90px;
            height: 30px;
            line-height: 30px;

            .van-button__text {
              font-weight: 500;
            }
          }
        }
      }
      .sub-txt {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 34px;
        height: 34px;
        min-height: 34px;
        margin: 60px 0 0 0;
        box-sizing: border-box;
      }
      .money-box {
        /* width: 30%; */
        display: flex;
        align-items: baseline;
        .sub-money {
          font-size: 24px;
          font-family: Cochin;
          color: #cccccc;
          line-height: 28px;
          margin-right: 20px;
          text-decoration: line-through;
        }
        .main-money {
          line-height: 28px;
        }
      }
    }
  }
}
/* 
::v-deep .van-tab {
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 4px;
  color: #646566;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  flex: none;
  margin-right: 20px;
}
::v-deep .van-tab--active .van-tab__text--ellipsis,
::v-deep .van-tab--active .van-tab__text {
  font-size: 24px;
  transition-property: color, background;
  transition-duration: 3s, 3s;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: var(--tc) !important;
}
::v-deep .van-tab__text--ellipsis {
  -webkit-line-clamp: unset;
  overflow: unset;
}
::v-deep .van-tabs__line {
  background: var(--tc) !important;
} */
</style>
